import React, { Children, useReducer } from 'react'
import { Swipeable } from 'react-swipeable'
import { CarouselSlot } from './carousel-slot'
import { useMobileCarouselStyles } from './mobile-carousel.styles'

export const PREV = 'PREV'
const NEXT = 'NEXT'

const getOrder = ({ index, position, numItems }) => {
  return index - position < 0
    ? numItems - Math.abs(index - position)
    : index - position
}

const mobileCarouselReducer = (state, { type, numItems }) => {
  switch (type) {
    case 'reset':
      return initialState
    case PREV:
      return {
        ...state,
        direction: PREV,
        sliding: true,
        position: state.position === 0 ? numItems - 1 : state.position - 1
      }
    case NEXT:
      return {
        ...state,
        direction: NEXT,
        sliding: true,
        position: state.position === numItems - 1 ? 0 : state.position + 1
      }
    case 'stopSliding':
      return { ...state, sliding: false }
    default:
      return state
  }
}

const initialState = { position: 1, sliding: false, direction: NEXT }

const MobileCarousel = ({ children, setSectionActive, initialPosition }) => {
  initialState.position = initialPosition || initialState.position
  const [state, dispatch] = useReducer(
    mobileCarouselReducer,
    initialState,
    undefined
  )
  const numItems = Children.count(children)
  const classes = useMobileCarouselStyles({
    direction: state.direction,
    sliding: state.sliding
  })

  const slide = direction => {
    let currentPosition =
      direction === NEXT ? state.position + 1 : state.position - 1

    currentPosition = currentPosition < 0 ? numItems - 1 : currentPosition
    currentPosition = currentPosition === numItems ? 0 : currentPosition

    dispatch({ type: direction, numItems })
    setSectionActive(currentPosition)
    setTimeout(() => {
      dispatch({ type: 'stopSliding' })
    }, 50)
  }

  return (
    <Swipeable
      className={classes.swipeable}
      onSwipedLeft={() => slide(NEXT)}
      onSwipedRight={() => slide(PREV)}
      preventDefaultTouchmoveEvent
      trackMouse
    >
      <div className={classes.wrapper}>
        <div className={classes.carouselContainer}>
          {Children.map(children, (child, index) => (
            <CarouselSlot
              key={index}
              order={getOrder({
                index: index,
                position: state.position,
                numItems
              })}
            >
              {child}
            </CarouselSlot>
          ))}
        </div>
      </div>
    </Swipeable>
  )
}

export default MobileCarousel
